const n = (e) => "items" in e;
export {
  n as isMenuGroup
};
